export default "__VITE_ASSET__CvtkRoMf__"